import React from 'react'
import './AppDeleteFromMainServerPopup.scss'
import Popup from '../../components/popup/Popup'
import { AppFlex } from '../../shared/ui/AppFlex/AppFlex'
import AppBtn, { AppBtnColor, AppBtnSize } from '../../components/btn/AppBtn'
import { useTranslation } from 'react-i18next'

interface AppDeleteFromMainServerPopupProps {
  onClose: () => void
  onDelete: () => void
  onOpenStationPopup: () => void
}

export const AppDeleteFromMainServerPopup = ({
  onClose,
  onDelete,
  onOpenStationPopup,
}: AppDeleteFromMainServerPopupProps) => {
  const { t } = useTranslation()
  const onDeleteHandler = () => {
    onDelete()
    onClose()
  }
  const onOpenStationPopupHandler = () => {
    onOpenStationPopup()
    onClose()
  }

  return (
    <Popup closePopup={onClose}>
      <AppFlex
        gap="20"
        direction="column"
        fullWidth
        className="delete-from-main-server"
      >
        <div className="title">
          <span>{t('Удалить с')}:</span>
          <div className="ico-block" onClick={onClose}>
            <i className="an-ico an-ico-close" />
          </div>
        </div>
        <div className="buttons-block full-width mt-15">
          <AppBtn
            sized={AppBtnSize.md}
            color={AppBtnColor.outlineViolet}
            title="Станции"
            // iconClassName="close"
            onClick={onOpenStationPopupHandler}
          />
          <AppBtn
            sized={AppBtnSize.md}
            color={AppBtnColor.violetWhite}
            // iconClassName="add"
            title="Центрального сервера"
            onClick={onDeleteHandler}
          />
        </div>
      </AppFlex>
    </Popup>
  )
}
